import http from 'plugins/axios';

export default {
  getUrlList({page,size,channelCode}){
return http.get({
  url:`/la/admin/channel/list?page=${page}&size=${size}&channelCode=${channelCode}`
})
  },
  getChannelInfo({page,size,id}){
return http.get({
  url:`/la/admin/channel/user/list?page=${page}&size=${size}&id=${id}`
})
  },


  delOne(id) {
    return http.post({
      url: `/la/admin/channel/del?id=${id}`,
    });
  },
  addOne(data) {
    return http.post({
      url: '/la/admin/channel/insert',
      data,
    });
  },
  updateUrl(data) {
    return http.post({
      url: '/la/admin/channel/change',
      data,
    });
  },
  // updateCode(data) {
  //   return http.post({
  //     url: '/la/admin/countryCode/update',
  //     data,
  //   });
  // },
};
